import React from "react";
import "./Footer.css";
import { netflixN, beefLogo } from "../data/assets";

const links = [
  { label: "Terms & Conditions", href: "/beef-release-your-rage/terms" },
  {
    label: "Privacy Language",
    href: "/privacy-and-terms",
  },
];

export default function Footer() {
  return (
    <footer className="beef-footer">
      <div className="beef-footer__inner beef-container">
        <div className="beef-footer__brand">
          <img className="beef-footer__n" src={netflixN} alt="Netflix" />
          <span className="beef-footer__divider" aria-hidden="true" />
          <img className="beef-footer__logo" src={beefLogo} alt="BEEF" />
        </div>
        <nav className="beef-footer__links" aria-label="Legal">
          {links.map((l) => {
            const external = /^https?:/.test(l.href);
            return (
              <a
                key={l.label}
                href={l.href}
                {...(external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
              >
                {l.label}
              </a>
            );
          })}
        </nav>
      </div>
    </footer>
  );
}
